import React from 'react';
import { useTranslation } from 'react-i18next';
import countries from './../../components/Countries';
import './InvoicingDetailsForm.css';

const InvoicingDetailsForm = ({ invoicingDetails, setInvoicingDetails, handleSaveInvoicingDetails, error }) => {
  const { t } = useTranslation();

  const handleInvoicingChange = (e) => {
    const { name, value } = e.target;
    setInvoicingDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleCountryChange = (e) => {
    const { name, value } = e.target;
    setInvoicingDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
      state: value === 'United States' ? prevDetails.state : '', // Clear state if country is not USA
    }));
  };

  return (
  <div className="space-y-6">
    {error && (
      <div className="bg-red-100 text-red-700 px-4 py-2 rounded-md text-sm">
        {error}
      </div>
    )}

    {/* Company Name */}
    <div>
      <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1">
        {t('subscription.companyName')}
      </label>
      <input
        type="text"
        id="companyName"
        name="companyName"
        value={invoicingDetails.companyName || ''}
        onChange={handleInvoicingChange}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
      />
    </div>

    {/* Country */}
    <div>
      <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1">
        {t('subscription.country')}
      </label>
      <select
        id="country"
        name="country"
        value={invoicingDetails.country || ''}
        onChange={handleCountryChange}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
      >
        <option value="">{t('subscription.selectCountry')}</option>
        {countries.map((country) => (
          <option key={country.code} value={country.name}>
            {country.name}
          </option>
        ))}
      </select>
    </div>

    {/* Address Lines */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label htmlFor="addressLine1" className="block text-sm font-medium text-gray-700 mb-1">
          {t('subscription.address')}
        </label>
        <input
          type="text"
          id="addressLine1"
          name="addressLine1"
          value={invoicingDetails.addressLine1 || ''}
          onChange={handleInvoicingChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        />
      </div>
      <div>
        <label htmlFor="addressLine2" className="block text-sm font-medium text-gray-700 mb-1">
          {t('subscription.addressLine2')}
        </label>
        <input
          type="text"
          id="addressLine2"
          name="addressLine2"
          placeholder={t('subscription.optional')}
          value={invoicingDetails.addressLine2 || ''}
          onChange={handleInvoicingChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        />
      </div>
    </div>

    {/* City and Postal Code */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
          {t('subscription.city')}
        </label>
        <input
          type="text"
          id="city"
          name="city"
          value={invoicingDetails.city || ''}
          onChange={handleInvoicingChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        />
      </div>
      <div>
        <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700 mb-1">
          {t('subscription.postalCode')}
        </label>
        <input
          type="text"
          id="postalCode"
          name="postalCode"
          value={invoicingDetails.postalCode || ''}
          onChange={handleInvoicingChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        />
      </div>
    </div>

    {/* State (only if US) */}
    {invoicingDetails.country === 'United States' && (
      <div>
        <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
          {t('subscription.state')}
        </label>
        <input
          type="text"
          id="state"
          name="state"
          value={invoicingDetails.state || ''}
          onChange={handleInvoicingChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        />
      </div>
    )}

    {/* VAT Number */}
    <div>
      <label htmlFor="vatNumber" className="block text-sm font-medium text-gray-700 mb-1">
        {t('subscription.vatNumber')}
      </label>
      <input
        type="text"
        id="vatNumber"
        name="vatNumber"
        value={invoicingDetails.vatNumber || ''}
        onChange={handleInvoicingChange}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
      />
    </div>

    {/* Save Button */}
    <div>
      <button
        onClick={handleSaveInvoicingDetails}
        className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700"
      >
        {t('subscription.saveDetails')}
      </button>
    </div>
  </div>
);

};

export default InvoicingDetailsForm;
